// Radha — customer portal link generation (staff side, migration 044). Creates
// a token row via the normal authenticated client (RLS scopes it to the caller's
// tenant; the trigger generates the token server-side). Public resolution of the
// token happens only inside the portal-statement Edge Function.
import { useMutation } from "@tanstack/react-query";

import { supabase } from "../lib/supabase";

export function useCreatePortalLink() {
  return useMutation({
    mutationFn: async (customerName: string): Promise<string> => {
      const { data, error } = await supabase
        .from("customer_portal_tokens")
        .insert({ customer_name: customerName })
        .select("token")
        .single();
      if (error) throw error;
      return `${window.location.origin}/?portal=${data.token}`;
    },
  });
}
